import { Button, InputLabel, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { APP_ICONS, APP_LOGO } from "../../../assets";
import AuthContainer from "../../../components/containers/AuthContainer";
import TextInput from "../../../components/textInput";

const ResetPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <AuthContainer>
      <Typography
        mt={2}
        fontSize={"1.5rem"}
        fontWeight={600}
        textAlign={"center"}
      >
        Reset Password
      </Typography>
      <Typography fontSize={"body1"} textAlign={"center"}>
        We have sent a verification code to abc@gmail.com
      </Typography>

      <Grid container rowSpacing={2} mt={4}>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Code</InputLabel>
          <TextInput />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>New Password</InputLabel>
          <TextInput />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Confirm Password</InputLabel>
          <TextInput />
        </Grid>
      </Grid>

      <Stack
        my={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={0.5}
      >
        <Link className="forgot-link" to={"/forgot-password"}>
          Back
        </Link>
      </Stack>

      <Button
        variant="contained"
        onClick={() => navigate("/login")}
        sx={{
          mt: 1,
          height: 45,
        }}
      >
        Reset Password
      </Button>
    </AuthContainer>
  );
};

export default ResetPasswordPage;
